// Origineel: client/imports/ui/Admin/AdminState.tsx (`AdminStateProvider`) en de plek ervan in
// client/imports/ui/index.tsx.
import { useMemo, useState, type ReactNode } from 'react';
import { getEmptyAssetIncidentMalfunctionData } from '@ame/shared';
import { AdminStateContext, type AdminState } from './AdminState';

type Props = {
  children: ReactNode;
  /** Alleen de beginwaarde, net als `useState(value)` in het origineel. */
  value: AdminState;
};

export function AdminStateProvider({ children, value }: Props) {
  const [state, setState] = useState(value);
  const waarde = useMemo(() => ({ state, setState }), [state]);
  return <AdminStateContext value={waarde}>{children}</AdminStateContext>;
}

/**
 * De gedeelde staat van het adminpaneel, om de hele app heen. De router mount deze component
 * boven alle routes; in het origineel stond `AdminStateProvider` op dezelfde manier om de
 * router in `index.tsx`, met deze beginwaarde.
 */
export default function AdminProviders({ children }: { children: ReactNode }) {
  // Eén keer maken: de provider gebruikt toch alleen de eerste waarde.
  const [beginwaarde] = useState<AdminState>(() => ({
    tasksOnTable: [],
    assets: getEmptyAssetIncidentMalfunctionData(),
  }));
  return <AdminStateProvider value={beginwaarde}>{children}</AdminStateProvider>;
}
